.root {
	--padding-h: var(--mantine-spacing-md);
	max-width: var(--container-size);
	overflow: auto;
	font-size: var(--mantine-font-size-lg);
}

.root :global(.katex-display) {
	max-width: var(--container-size);
	overflow: visible;
	font-size: smaller;
}

.root img {
	max-width: 100%;
}

.root li:not(:last-of-type) {
	margin-bottom: var(--mantine-spacing-md);
}

.role_assistant {
	overflow: auto;
	padding: 0 var(--padding-h);
}

/* # Role: User */

.role_user {
	font-weight: 600;
	padding: var(--mantine-spacing-md) var(--padding-h);
}

:global(html[data-mantine-color-scheme="light"]) .role_user {
	background: var(--mantine-color-gray-1);
}

:global(html[data-mantine-color-scheme="dark"]) .role_user {
	background: var(--mantine-color-dark-6);
}

/* # Error */

.hasError {
	color: var(--mantine-color-dimmed);
}

.error {
	color: var(--mantine-color-error);
	font-size: small;
	margin-top: var(--mantine-spacing-md);
}
